import { addBroadcastMessageListener } from '@/shared/helpers/broadcast.helpers';
import type { IPlatformIncident } from '@/shared/services/sw.types';
import { compact, last } from 'lodash';
import { computed, ref, watch } from 'vue';

const platformIncidents = ref<IPlatformIncident[] | null>([]);
addBroadcastMessageListener<IPlatformIncident[] | null>('fetchedPlatformIncidents', v => {
    platformIncidents.value = v;
});

export const usePlatformIncidents = () => {
    const openPlatformIncidents = computed(() => platformIncidents.value?.filter(i => i.human_status !== 'Fixed'));
    const latestOpenPlatformIncident = computed(() => openPlatformIncidents.value?.[0] || null);
    const openPlatformIncidentId = computed(() =>
        latestOpenPlatformIncident.value
            ? compact([
                  latestOpenPlatformIncident.value.id,
                  last(latestOpenPlatformIncident.value.updates)?.id ?? -1,
                  latestOpenPlatformIncident.value.human_status
              ]).join(':')
            : ''
    );
    const latestAcknowledgedPlatformIncidentId = ref(localStorage.getItem('zs:acknowledgedIncidentId') || '');
    watch(latestAcknowledgedPlatformIncidentId, value => localStorage.setItem('zs:acknowledgedIncidentId', value ?? ''));
    const hasPlatformIncidentUpdate = computed(() => openPlatformIncidentId.value !== latestAcknowledgedPlatformIncidentId.value);

    const openOrAckPlatformStatus = () => {
        latestAcknowledgedPlatformIncidentId.value = openPlatformIncidentId.value;
        const incidentId = openPlatformIncidentId.value.split(':')[0];
        if (incidentId) {
            window.open(`https://status.zyno.app/incidents/${incidentId}`, 'zynoStatus');
        }
    };

    return {
        platformIncidents,
        openPlatformIncidents,
        hasPlatformIncidentUpdate,
        openOrAckPlatformStatus
    };
};
